import { Component, Inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-validate-affranchi',
  imports: [MatCardModule, MatButtonModule],
  templateUrl: './generic-validate.component.html',
  styleUrl: './generic-validate.component.css',
})
export class GenericValidateComponent implements OnInit{
  constructor(private dialogRef: MatDialogRef<GenericValidateComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {}

  libelle: string = ''

  ngOnInit(): void {
    this.libelle = this.data.libelle;
  }

  closeDialog() {
    this.dialogRef.close();
  }

  validateDialog() {
    this.dialogRef.close(true);
  }
}
